import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { forwardRef, useMemo, useState } from 'react';
import { jsx } from '@emotion/core';
import { Popper } from '@atlaskit/popper';
import { RepositionOnUpdate } from './RepositionOnUpdate';
import { popupCSS } from './styles';
import { useCloseManager } from './useCloseManager';
import { useFocusManager } from './useFocusManager';
var DefaultPopupComponent = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx("div", _extends({
    css: popupCSS,
    ref: ref
  }, props));
});

function PopperWrapper(_ref) {
  var isOpen = _ref.isOpen,
      id = _ref.id,
      offset = _ref.offset,
      testId = _ref.testId,
      content = _ref.content,
      onClose = _ref.onClose,
      boundary = _ref.boundary,
      rootBoundary = _ref.rootBoundary,
      shouldFlip = _ref.shouldFlip,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
      _ref$popupComponent = _ref.popupComponent,
      PopupContainer = _ref$popupComponent === void 0 ? DefaultPopupComponent : _ref$popupComponent,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      triggerRef = _ref.triggerRef;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popupRef = _useState2[0],
      setPopupRef = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      initialFocusRef = _useState4[0],
      setInitialFocusRef = _useState4[1];

  useFocusManager({
    initialFocusRef: initialFocusRef,
    popupRef: popupRef
  });
  useCloseManager({
    isOpen: isOpen,
    onClose: onClose,
    popupRef: popupRef,
    triggerRef: triggerRef
  });
  var modifiers = useMemo(function () {
    return [{
      name: 'flip',
      enabled: shouldFlip,
      options: {
        rootBoundary: rootBoundary,
        boundary: boundary
      }
    }];
  }, [shouldFlip, rootBoundary, boundary]);
  return jsx(Popper, {
    placement: placement,
    offset: offset,
    modifiers: modifiers
  }, function (_ref2) {
    var _ref3 = _ref2.ref,
        style = _ref2.style,
        placement = _ref2.placement,
        update = _ref2.update;
    return jsx(PopupContainer, {
      id: id,
      "data-placement": placement,
      "data-testid": testId,
      ref: function ref(node) {
        if (node) {
          if (typeof _ref3 === 'function') {
            _ref3(node);
          } else {
            _ref3.current = node;
          }

          setPopupRef(node);
        }
      },
      style: style // using tabIndex={-1} would cause a bug where Safari focuses
      // first on the browser address bar when using keyboard
      ,
      tabIndex: autoFocus ? 0 : undefined
    }, jsx(RepositionOnUpdate, {
      update: update
    }, content({
      update: update,
      isOpen: isOpen,
      onClose: onClose,
      setInitialFocusRef: setInitialFocusRef
    })));
  });
}

export default PopperWrapper;